var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconeProfilBlueFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 54.33 52.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#152440;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 27.17,
    cy: 15.83,
    r: 15.83
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,52.39C3.36,37,8.12,32.75,12,31.82c4.48-1.07,6.75,2.59,15.06,2.84,8.57.25,11.18-3.5,15.87-2.19,3.74,1,8.41,5.21,11.45,19.92Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeProfilBlueFilled);
export default __webpack_public_path__ + "static/media/icone_profil_blue_filled.a82494f3eae6fc8c3ec31ac93a9e8ea6.svg";
export { ForwardRef as ReactComponent };